module.exports = __webpack_public_path__ + "img/Collapse-drawerDarckGray.a85e0b7d.svg";